<template>
<vue-custom-scrollbar class="scroll-area">
    <div class="login-container login-page">

        <div class="login-header login-caret">
            <div class="logo-content">
                <!-- <template v-if="!currentRouteBase">
                    {{ $t("source") }}
                </template>
                <template v-if="currentRouteBase">
                    {{ $t('Sourcelms') }}
                </template> -->

                <img
                    v-if="globalLogo"
                    :src="env.media_url + '/' + globalLogo"
                    alt="School"
                >
                <img
                    v-else
                    :src="env.public_base + '/assets/images/sourcelms-logo.svg'"
                    width="183"
                    height="34"
                    alt="School"
                >
            </div>
            <h4 class="description">{{ $t('enter_reset_password') }}</h4>
        </div>

        <div class="login-form">
            <div class="login-content">
                <form method="post" role="form" id="form_login" novalidate="novalidate"
                      @submit.prevent="validateBeforeSubmit">

                    <h5 class="login-content__title">{{$t('resetBy')}}</h5>

                    <div class="login-type">
                        <button type="button" class="type__item" @click="loginType = 'email'"
                                :class="{'active': loginType === 'email'}">

                            <svg width="21" height="14" viewBox="0 0 21 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.01072 0.827077L9.21462 6.53333C9.54129 6.79179 9.99144 6.90667 10.4287 6.88513C10.8652 6.90667 11.3153 6.79251 11.642 6.53333L18.8459 0.827077C19.4231 0.372615 19.2925 0 18.5602 0H10.4294H2.29862C1.56559 0 1.43493 0.372615 2.01072 0.827077Z" fill="#A1A9B"/>
                                <path d="M19.366 2.3327L11.4937 8.30962C11.1994 8.53075 10.8138 8.63844 10.4297 8.63342C10.0449 8.63844 9.65938 8.53003 9.36502 8.30962L1.49127 2.3327C0.906865 1.88972 0.428711 2.12737 0.428711 2.86039V12.6669C0.428711 13.3999 1.02892 14.0001 1.76194 14.0001H10.4283H19.0954C19.8284 14.0001 20.4286 13.3999 20.4286 12.6669V2.86039C20.4286 2.12737 19.9505 1.88972 19.366 2.3327Z" fill="#A1A9B"/>
                            </svg>

                            <span>{{$t('email')}}</span>
                        </button>

                        <button type="button" class="type__item" @click="loginType = 'phone'"
                                :class="{'active': loginType === 'phone'}">

                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.6413 12.6552L13.1704 10.1784C12.6782 9.6871 11.8632 9.70203 11.3538 10.2127L10.109 11.4601C10.0303 11.4167 9.94891 11.3713 9.86332 11.3231C9.07719 10.8866 8.00124 10.2882 6.86903 9.15259C5.73347 8.01458 5.1359 6.93454 4.69898 6.14613C4.65288 6.0626 4.6087 5.98207 4.56508 5.90559L5.40057 5.06945L5.81133 4.65725C6.32143 4.14586 6.33549 3.32921 5.84448 2.83648L3.37353 0.359373C2.88251 -0.132666 2.0671 -0.117739 1.55701 0.39365L0.860608 1.09563L0.879638 1.11457C0.646127 1.4132 0.450997 1.75763 0.305788 2.12905C0.171932 2.4826 0.0885942 2.81998 0.0504876 3.15805C-0.275785 5.86906 0.960265 8.34671 4.31474 11.7088C8.95165 16.3559 12.6884 16.0049 12.8496 15.9877C13.2007 15.9457 13.5372 15.8616 13.8791 15.7285C14.2465 15.5847 14.5899 15.3894 14.8877 15.1558L14.9029 15.1694L15.6084 14.477C16.1174 13.9657 16.1321 13.1487 15.6413 12.6552Z" fill="#A1A9B"/>
                            </svg>

                            <span>{{$t('phone')}}</span>
                        </button>
                    </div>

                    <div class="form-group" :class="{'form-group--hidden' : loginType === 'phone'}">
                        <div class="input-group" :class="{'validate-has-error' : errors.has('email')}">
                            <div class="input-group-addon">
                                <i class="entypo-user"></i>
                            </div>

                            <input type="text"
                                   class="form-control"
                                   name="email"
                                   id="email"
                                   :placeholder="$t('email')"
                                   autocomplete="off"
                                   v-validate="loginType === 'email' ? 'required|email' : ''"
                                   v-model="email"
                            >
                        </div>
                        <label v-if="errors.has('email')" id="login-error" class="error" for="email">{{
                            errors.first('email') }}</label>
                    </div>

                    <div class="form-group" :class="{'form-group--hidden' : loginType === 'email'}">
                        <div class="input-group" :class="{'validate-has-error' : errors.has('phone')}">
                            <div class="input-group-addon"><i class="entypo-phone"></i></div>
                            <input
                                    type="text"
                                    class="form-control"
                                    id="phone"
                                    name="phone"
                                    autocomplete="off"
                                    placeholder="+"
                                    v-validate="loginType === 'phone' ? {required: true, min: 10} : ''"
                                    v-model="phone"
                            >
                        </div>
                        <label v-if="errors.has('phone')" id="phone-error" class="error" for="phone">{{
                            errors.first('phone') }}</label>
                    </div>
                    <div class="email-error" v-if="resetPassword && resetPassword.error">
                        {{$t('resetPasswordError')}}
                    </div>
                    <div class="form-group">
                        <button type="submit" class="btn btn-info btn-block btn-login">
                            {{ $t('reset_password') }}
                            <i class="entypo-right-open-mini"></i></button>
                    </div>
                </form>

                <div class="login-bottom-links">
                    <router-link to="/login" class="link">
                        {{ $t('back') }}
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</vue-custom-scrollbar>
</template>

<script>
    import {mapGetters} from 'vuex';
    import env from '../env';
    import vueCustomScrollbar from "vue-custom-scrollbar";

    export default {
        components: {
            vueCustomScrollbar,
        },
        data: function () {
            return {
                env,
                loginType: 'email',
                email: '',
                phone: '',
                globalLogo: window.school_logo,
            }
        },
        computed: {
            ...mapGetters([
                'loggedInHash',
                'resetPassword',
            ]),
            currentRouteBase() {
                return location.host === 'demo.sourcelms.com'
            },
        },
        methods: {
            validateBeforeSubmit() {
                let $vm = this;
                $vm.$validator.validateAll().then((result) => {
                    if (result) {
                        $vm.$store.dispatch('resetPassword', {
                            'login': $vm.loginType == 'email' ? $vm.email : $vm.phone,
                            'school_id': window.school_id
                        }).then(res => {
                                if (res) this.$router.push({name: 'login'})
                            }
                        ), err => console.log(err, "error");
                    }
                });
            }
        },
        watch: {
            loggedInHash: function () {
                //this.$router.push({name: 'login'});
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../sass/variables';

    .logo-content {
        position: relative;
        width: 320px;
        margin: 0 auto;
        text-align: center;
        padding: 20px 0;
        vertical-align: middle;
        white-space: nowrap;
        font-size: 17px;
        font-weight: 900;
        text-transform: uppercase;
        letter-spacing: .38em;
        color: white;

        img {
            max-width: 100%;
        }
    }

    .login-page .login-header .description {
        width: 450px;
        margin: 0 auto;
        text-align: center;
        max-width: 100%;
        font-size: 15px;
        color: $white;
    }

    .login-page .login-form .form-group .btn-login {
        font-size: 13px;
    }

    .login-page .login-form .form-group .input-group.validate-has-error .error {
        position: absolute;
        right: 10px;
        top: 50%;
        margin-top: -8px;
        font-size: 10px;
    }

    .login-type {
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: space-around;
    }

    .login-type .type__item {
        position: relative;
        display: flex;
        align-items: center;
        margin: 0;
        padding: 0 0 10px 0;

        color: #A1A9B6;
        line-height: 1;
        background: transparent;

        svg {
            fill: #A1A9B6;
        }

        span {
            margin-left: 10px;
        }

        &::after {
            content: '';
            position: absolute;
            z-index: 1;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 2px;
            background-color: $accent;

            display: none;
        }

        &.active {
            color: $accent;

            svg {
                fill: $accent
            }

            &::after {
                display: block;
            }
        }
    }


    .form-group--hidden {
        display: none;
    }

    .email-error {
        margin: 15px 0 20px;
    }

    .scroll-area {
        height: 100%;
    }

</style>
